module.exports = __webpack_public_path__ + "img/yuyuesuochang.a9f60e10.png";